import Vue from 'vue';
import Vuex from 'vuex';
import models from '@/store/models';
import uis from '@/store/uis';
import platform from './platform';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    platform,
    ...models,
    ...uis,
  },
  getters: {
    baseUrl() {
      return INDEEGO_BASE_URL; // eslint-disable-line
    },
  },
});
